import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store'
import './index.css';
import App from './App';
import { setAxiosAccessToken } from './services/helpers';

setAxiosAccessToken();

// createRoot batches the store updates from one game update into one render, so what changed is seen as one move.
createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
